import type { ReactElement } from 'react';
import type { DiffLine } from '@/lib/templateRender';

/**
 * The ONE line-diff renderer — template-vs-template (FieldDiffModal) and
 * version-vs-version (VersionDiffPanel, tracker row 8) both draw their lines
 * here: removed lines red + struck through, added lines highlighted
 * (`addedBg`; the template compare keeps its historical yellow, the version
 * diff uses green), unchanged lines plain.
 */
export function DiffLineList({
  lines,
  addedBg = '#fef9c3',
  maxHeight = '46vh',
  testId,
}: {
  lines: ReadonlyArray<DiffLine>;
  addedBg?: string;
  maxHeight?: string;
  testId?: string;
}): ReactElement {
  return (
    <pre
      data-testid={testId}
      style={{
        margin: 0,
        padding: 12,
        maxHeight,
        overflow: 'auto',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        fontSize: 12,
        lineHeight: 1.5,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {lines.map((ln, idx) => {
        const bg = ln.type === 'added' ? addedBg : ln.type === 'removed' ? '#fee2e2' : 'transparent';
        return (
          <div
            key={idx}
            data-difftype={ln.type}
            style={{
              background: bg,
              textDecoration: ln.type === 'removed' ? 'line-through' : 'none',
              color: ln.type === 'removed' ? '#991b1b' : 'inherit',
            }}
          >
            {ln.text === '' ? ' ' : ln.text}
          </div>
        );
      })}
    </pre>
  );
}
